$(".c-slide__slider").slick({
  nextArrow: $(".c-slider__next"),
  prevArrow: $(".c-slider__prev"),
});

$(".c-slide__slider").on(
  "init reInit afterChange",
  function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".pagingSlider").text(i + "/" + slick.slideCount);
  }
);

$("#book-a-demo-testimonials .c-testimonials").slick({
  nextArrow: $(".c-testimonial__next"),
  dots: true,
  adaptiveHeight: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
});

$(".c-posts-slider .container").slick({
  nextArrow: $(".c-testimonial__next"),
  adaptiveHeight: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  dots: true,
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".c-events-slider__slider").slick({
  adaptiveHeight: true,
  infinite: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  dots: true,
});

if (document.querySelector(".c-posts-slider .slick-track")) {
  const sliderTrack = document.querySelector(".c-posts-slider .slick-track");
  document
    .querySelector(".c-posts-slider")
    .style.setProperty(
      "--slider-post-height",
      sliderTrack.clientHeight - 50 + "px"
    );
}

$(".c-image-slider__wrapper").slick({
  dots: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: true,
  arrows: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".c-testimonials").slick({
  nextArrow: $(".c-testimonial__next"),
  dots: true,
  adaptiveHeight: true,
});
$(".c-testimonials").on(
  "init reInit afterChange",
  function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".pagingTestimonial").text(i + "/" + slick.slideCount);
  }
);
$(".c-block-tabs__slide").slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: false,
});

$(".c-posts__slider").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  dots: true,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});
